// Auto-generated by Firefoo v1.5.11 on 2023-11-11 14:58:19 UTC

import { gigStatuses } from 'constants/optionLists';
import { FlexDetailsField, Venue, AttireByTag } from './event';
import { EntType } from './config';

export interface ContractorNote {
  desc: string;
  note: string;
}

export interface Gig {
  callTime?: Date | null;
  category?: string;
  contractLinkDesc_1?: string;
  contractLinkUrl_1?: string;
  contractStatus: (typeof gigStatuses)[number];
  contractAttire?: string;
  contractor?: Contractor;
  contractorNotes?: ContractorNote[];
  createdBy: string;
  createdDate: Date | null;
  id: string;
  internalNotes?: string;
  linkJobSheet?: Date | null;
  modifiedBy: string;
  modifiedDate: Date | null;
  modifiedTime: string;
  isSectionLead?: boolean;
  prime?: 'Prime' | 'Non-prime';
  performanceNotes?: string;
  hidden?: boolean;
  objectID?: string;
  order?: number;
  rates: Rate[];
  extraProjections?: TalentCostTemplate[];
  relEventDate: Date | null;
  relEventId: string;
  relEventName: string;
  relVendorId: string;
  relVendorName?: string;
  relVendorRate?: number;
  relVendorSkill?: string;
  role?: string;
  callOrder?: number;
  talWageD?: number;
  topParent: string | null;
  topSecret: boolean;
  oneUpParent: string | null;
  twoUpParent: string | null;
}

export interface DashboardEventData {
  dateStart: Date | null;
  eventTitle: string;
  attire: string;
  attireByContactTag?: AttireByTag[];
  timeStart?: Date | null;
  timeEnd?: Date | null;
  eventType: EntType;
  venue?: Venue;
  avTech?: string;
  flexDetailsFields: FlexDetailsField[];
  staticDetailsFields: {
    [key: string]: string;
  };
}

export type DashboardGig = DashboardEventData & Gig;

export interface Contractor {
  id: string;
  name: string;
}

export interface Rate {
  amount: number;
  type: string;
}

export type ProjectionDecision = 'accepted' | 'rejected';

export interface TalentCostTemplate {
  id: string;
  name: string;
  description?: string;
  amount?: number;
  projectionDecision?: ProjectionDecision;
  createdAt?: Date;
  modifiedAt?: Date;
}

export interface TalentCostAssignment {
  amount: number;
  templateName: string;
  modifiedAt: any;
}

export const gigInit = {
  callTime: '',
  category: '',
  contractLinkDesc_1: '',
  contractLinkUrl_1: '',
  contractStatus: '',
  contractor: {
    id: '',
    name: ''
  },
  contractorNotes: [],
  createdBy: '',
  createdDate: null,
  internalNotes: '',
  linkJobSheet: null,
  modifiedBy: '',
  modifiedDate: null,
  modifiedTime: '',
  isSectionLead: false,
  prime: '',
  order: 0,
  rates: [
    {
      amount: 0,
      type: 'baseRate'
    }
  ],
  extraProjections: [],
  relEventDate: null,
  relEventId: '',
  relEventName: '',
  relVendorId: '',
  relVendorName: '',
  relVendorRate: 0,
  relVendorSkill: '',
  role: '',
  talWageD: 0,
  topParent: ''
};

export const dashboardEventDataInit: DashboardEventData = {
  dateStart: null,
  eventTitle: '',
  attire: '',
  attireByContactTag: [],
  timeStart: null,
  timeEnd: null,
  eventType: {
    id: '',
    name: '',
    color: ''
  },
  staticDetailsFields: {},
  flexDetailsFields: []
};
